const dict = {
  en: {
    nav_studio: 'Studio',
    nav_export: 'Export',
    nav_hov: 'HOV',
    nav_localize: 'Localize',
    nav_settings: 'Settings',
    settings_appearance: 'Appearance',
    settings_language: 'Language',
    settings_apikeys: 'API Keys',
    appearance_title: 'Appearance',
    appearance_theme: 'Theme',
    appearance_light: 'Light',
    appearance_dark: 'Dark',
    appearance_auto: 'Auto',
    appearance_soon: 'Dark mode active',
    language_title: 'Language',
    language_label: 'App language',
    language_soon: 'Full translation coming soon',
    apikeys_title: 'API Keys',
    apikeys_subtitle: 'Injected from Railway — read only.',
    // ── Settings tab (5 blocks) ──────────────────────────────────
    'settings.deadlines': 'Deadlines',
    'settings.connections': 'Connections',
    'settings.notifications': 'Notifications',
    'settings.account': 'Account',
    'settings.naming': 'Naming convention',
    // Deadlines block
    'settings.overdue': 'overdue',
    'settings.under': 'under',
    'settings.days_short': 'd',
    'settings.loading': 'Loading…',
    'settings.backend_unreachable': 'Backend unreachable',
    'settings.nothing_expires_pre': 'Nothing expires in the next',
    'settings.nothing_expires_post': 'days.',
    'settings.heartbeat_running': 'Heartbeat…',
    'settings.heartbeat_ok': '✓ woke up',
    'settings.heartbeat_do': '↯ Wake up (heartbeat)',
    'settings.meta_token_link': '→ System User token (removes this deadline)',
    // Connections block
    'settings.conn_all': 'All',
    'settings.conn_issues': 'Issues',
    'settings.conn_unconfigured': 'Unconfigured',
    'settings.refresh_title': 'Refresh (bypass cache)',
    'settings.cannot_reach': 'Unable to reach',
    'settings.querying_services': 'Querying the 8 services…',
    'settings.hide_key': 'Hide my key',
    'settings.configure_key': 'Configure my key (browser)',
    'settings.checked': 'Checked',
    'settings.cache': 'cache',
    'settings.realtime': 'real time',
    'settings.keys_note': 'server keys live on Railway; "my key" above is yours, in this browser.',
    // Notifications block
    'settings.notif_banner': 'In-app banner',
    'settings.notif_banner_desc': 'Alert at the top of the tabs',
    'settings.notif_slack': 'Slack',
    'settings.notif_slack_desc': 'Weekly recap webhook (already set up)',
    'settings.notif_email': 'Email',
    'settings.notif_email_desc': 'To be wired later',
    'settings.col_rule': 'Rule',
    'settings.col_threshold': 'Threshold',
    'settings.col_level': 'Level',
    'settings.rule_expiry': 'Token / key nearing expiry',
    'settings.rule_quota': 'A service quota exceeded',
    'settings.rule_deploy': 'Deployment failed',
    'settings.rule_sha': 'Prod SHA ≠ main',
    'settings.rule_failopen': 'Auth disabled (fail-open)',
    'settings.rule_payment': 'Payment declined / account suspended',
    'settings.rule_nosync': 'No successful sync since',
    'settings.def_expiry': '14 d before',
    'settings.def_quota': '80 %',
    'settings.def_deploy': '1st failure',
    'settings.def_sha': 'after 30 min',
    'settings.def_immediate': 'immediate',
    'settings.def_nosync': '48 h',
    'settings.level_broken': 'Broken',
    'settings.level_warn': 'Warning',
    'settings.legend_unconfigured': 'Unconfigured',
    // Account block
    'settings.session': 'Session',
    'settings.acct_account': 'Account',
    'settings.not_connected': 'Not connected',
    'settings.owner': 'Owner',
    'settings.guest': 'Guest',
    'settings.workspace': 'Workspace',
    'settings.shared': 'Shared',
    'settings.front_vercel': 'Front (Vercel)',
    'settings.build': 'build',
    'settings.not_exposed': 'not exposed',
    'settings.backend_railway': 'Backend (Railway)',
    'settings.github_token_absent': 'GITHUB_TOKEN missing',
    'settings.preferences': 'Preferences',
    'settings.theme': 'Theme',
    'settings.theme_light': 'Light',
    'settings.theme_dark': 'Dark',
    'settings.theme_auto': 'Auto',
    'settings.language': 'Language',
    'settings.date_format': 'Date format',
    'settings.waiting_phrases': 'Loading phrases',
    'settings.waiting_phrases_hint': 'Shown during rendering; they rotate with progress, the counter (2/3) is added automatically.',
    'settings.add': '+ Add',
    'settings.branding': 'Branding',
    'settings.brand_name': 'Brand name',
    'settings.brand_subtitle': 'Subtitle',
    'settings.no_logo': 'No logo',
    'settings.replace': 'Replace',
    'settings.replay_tutorial': 'Replay the tutorial',
    'settings.logout': 'Log out',
    // Naming convention block
    'settings.model': 'Template',
    'settings.live_preview': 'Live preview',
    'settings.creator': 'Creator',
    'settings.duration': 'Duration',
    'settings.persona': 'Persona',
    'settings.category': 'Category',
    'settings.feature': 'Feature',
    'settings.list_categories': 'Categories · _CAT-',
    'settings.list_personas': 'Personas · _PERSONA-',
    'settings.list_durations': 'Durations · _DUR-',
    'settings.offnom_title': 'Live creatives without a _CAT- block',
    'settings.offnom_desc': 'Detection lives in Performance (the "⚠ creative(s) without category" panel), closest to the Meta data. v2 names have no _CAT- block by design and are never flagged. We don\'t re-count the pipeline here to avoid showing a number that could lie.',
    'settings.open_performance': 'Open Performance →',
    'settings.chip_add': '+ add',
    studio_drop: 'Drag & drop any file',
    studio_formats: 'MP4 · Max size: 500MB',
    studio_multi: 'You can upload multiple files',
    studio_feature: 'FEATURE',
    studio_hooks: 'Hooks',
    studio_no_hooks: 'No hooks yet',
    studio_scripts: 'Script',
    studio_title: 'Title',
    studio_voice: 'Voice',
    studio_music: 'Sound',
    studio_generate: 'Generate',
    studio_overlay: 'Overlay',
    studio_color: 'COLOR',
    studio_size: 'SIZE',
    studio_direction: 'DIRECTION',
    studio_mix: 'MIX',
    studio_bandeau: 'BANDEAU',
    studio_texte: 'TEXT',
    studio_lignes: 'LINES',
    studio_female: 'FEMALE',
    studio_male: 'MALE',
    studio_replace: 'Replace',
    studio_keep_orig: 'Keep orig',
    studio_mix_all: 'Mix all',
    studio_no_music: 'No music',
    studio_add_tracks: 'Add track(s)',
    studio_add_voice: 'Add voice',
    studio_add_videos: 'Add videos first',
    export_title: 'Export',
    hov_title: 'HOV',
    save: 'Save',
    reset: 'Reset',
    cancel: 'Cancel',
    confirm: 'Confirm',
    on: 'on',
    off: 'off',
  },
};

// English only (CLAUDE.md "UI language"): the FR/ES dictionaries and the language picker were
// removed on 2026-10-06. `lang` is kept in the signature so callers don't change.
export function useTranslation(lang) { // eslint-disable-line no-unused-vars
  return (key) => dict.en[key] || key;
}

export default dict;
